/* @flow */

import { rem } from 'polished';

import { borderRadius } from 'src/shared/app/base/style/token/box';
import { cardBaseColor, baseColor } from '@e180/ui/lib/token/color';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  overlay: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    width: '80%',
    maxWidth: 400,
    padding: [rem(16, baseFontSize)],

    color: baseColor,
    backgroundColor: cardBaseColor,
    borderRadius,
  },
  message: {
    margin: [0, 0, rem(16, baseFontSize)],
  },
};
